module.exports = "https://staticsandbox.coteibem.com.br/assets/logo-nocolor-flat.0ffe77f6452766d602ad6bffd3096dc7.png";